<template>
  <div class="entry-page">
    <div class="loading-tip">正在进入...</div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

/** 3月29日之前进入首页，29号及以后进入座次查询 */
function getRedirectPath() {
  const now = new Date();
  const march29 = new Date(now.getFullYear(), 2, 29); // 2 = March
  return now >= march29 ? '/seats' : '/home';
}

onMounted(() => {
  const path = getRedirectPath();
  router.replace(path);
});
</script>

<style scoped>
.entry-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("../assets/bg/background-3.jpg") 100% 100% no-repeat;
  background-size: cover;
}

.loading-tip {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
}
</style>
